<div class="main vaccine-list global-table-wrapper">
    <div class="title-btn">
        <div class="main-title">
            <h1>Vaccine List</h1>
            <p>Show your vaccine list information</p>
        </div>
        <div class="new-placement" *appHasRole="['Admin', 'Farm manager']">
            <a routerLink="/add-vaccine" class="btn btn-action-primary"
                ><i class="fas fa-plus"></i> New Vaccine</a
            >
        </div>
    </div>
    <app-search-filter
        [config]="filterConfig"
        [userId]="currentUserId"
        (filter)="onCustomFilter($event)"
        (clear)="onCustomFilterClear()"
    ></app-search-filter>

    <p-table [value]="data" responsiveLayout="scroll" [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th>Batch Number</th>
                <th>Brand</th>
                <th>Classification</th>
                <th>Quantity</th>
                <th>Expiry Date</th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.batchNumber }}</td>
                <td>{{ item.brand }}</td>
                <td>
                    {{
                        splitByUpperCase(getVaccineTypeName(item.vaccineTypeId))
                    }}
                </td>
                <td>{{ item.qty }}</td>
                <td>
                    {{ item.expireDate | date: 'dd/MM/yyyy' }}
                    <span
                        *ngIf="
                            item.expireDate &&
                            (item.expireDate | date: 'yyyy-MM-dd') <
                                (today | date: 'yyyy-MM-dd')
                        "
                        class="badge badge-expired"
                        >Expired</span
                    >
                </td>
                <ng-container *appHasRole="['Admin', 'Farm manager']">
                    <td>
                        <a
                            [routerLink]="['/edit-vaccine', item.id]"
                            pTooltip="Edit"
                            tooltipPosition="top"
                            class="table-action-icon"
                            ><i class="far fa-edit"></i
                        ></a>
                    </td>
                    <td>
                        <a
                            (click)="deleteVaccine(item.id)"
                            pTooltip="Vaccine Delete"
                            tooltipPosition="top"
                            class="table-action-icon"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                    <td>
                        <a
                            [routerLink]="['/vaccine-detail', item.id]"
                            pTooltip="Vaccine Detail"
                            tooltipPosition="top"
                            class="table-action-icon"
                            ><i class="fas fa-info-circle"></i
                        ></a>
                    </td>
                </ng-container>
            </tr>
        </ng-template>
    </p-table>
    <p-paginator
        *ngIf="isPaginator"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        styleClass="p-paginator-bottom"
    ></p-paginator>

    <!-- delete medication -->
    <p-dialog
        [(visible)]="displayDeleteDialog"
        model="true"
        [closable]="true"
        [style]="{width: '400px'}"
        [responsive]="true"
    >
        <p class="text-center">Are you sure you want to delete?</p>
        <div class="text-center">
            <button (click)="deleteItem()" class="btn btn-primary mr-1">
                Yes
            </button>
            <button
                (click)="displayDeleteDialog = false"
                class="btn btn-secondary"
            >
                No
            </button>
        </div>
    </p-dialog>
</div>
